<span class="left-text" [class.text-lock]="showLock">{{ leftText }}</span>
<span *ngIf="middleText" class="middle-text">{{ middleText }}</span>
<span class="icons">
  <fa-icon
    *ngIf="actions && !disabled"
    class="clickable"
    [icon]="faPen"
    (click)="onEditClick($event)"
    stopClickPropagation
  ></fa-icon>
  <fa-icon
    *ngIf="actions && !disabled"
    class="delete-icon clickable"
    [icon]="faTrash"
    (click)="onDeleteClick($event)"
    stopClickPropagation
  ></fa-icon>
  <fa-icon *ngIf="!disabled && arrow" [rotate]="90" [icon]="faSortUp"></fa-icon>
  <fa-icon *ngIf="showLock" class="lockIcon" [icon]="faLock"></fa-icon>
  <div
    *ngIf="isDropdown && !disabled"
    class="arrow-container"
    (click)="onArrowClick($event)"
    stopClickPropagation
  >
    <div [class]="dropdownOpen ? 'up-arrow' : 'down-arrow'"></div>
  </div>
</span>
